export default __webpack_public_path__ + "static/media/background-image-3.17ee37f6.jpg";